<template>
  <div :class="classObject" v-click-outside="onClickOutside">
    <datepicker
      v-model="datepickerValue"
      :name="name"
      :format="customFormatter"
      :monday-first="true"
      :disabled-dates="disabledDates"
      wrapper-class="c-datepicker__wrapper"
      input-class="c-form__input c-datepicker__input"
      @opened="isOpen = true"
      @closed="isOpen = false"
      @selected="onDateSelected"
    >
      <div slot="afterDateInput" class="c-datepicker__icon">
        <icon name="calendar" height="20" width="20"></icon>
      </div>
    </datepicker>

    <div class="c-datepicker__input-group">
      <input
        class="c-datepicker__input-item c-datepicker__input-item--day"
        v-model="editableDay"
        type="text"
        maxlength="2"
      >
      <span>/</span>
      <input
        class="c-datepicker__input-item c-datepicker__input-item--month"
        v-model="editableMonth"
        type="text"
        maxlength="2"
      >
      <span>/</span>
      <input
        class="c-datepicker__input-item c-datepicker__input-item--year"
        v-model="editableYear"
        type="text"
        maxlength="4"
      >
    </div>

    <span class="c-form__validation-message" v-if="error">{{ error }}</span>
  </div>
</template>


<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'form-datepicker',

  data() {
    return {
      isOpen: false,
      datepickerValue: this.value
    };
  },

  $_veeValidate: {
    value() {
      return this.$dayjs(this.datepickerValue).format('YYYY-MM-DD');
    },
  },

  props: {
    value: [Date, String],
    name: String,
    id: [Number, String],
    error: String,
    format: [String, Function],
    disabledDates: Object,
    small: Boolean,
  },

  computed: {
    classObject() {
      return {
        'c-datepicker': true,
        'c-datepicker--small': this.small,
        'is-open': this.isOpen,
        'is-closed': !this.isOpen,
      };
    },

    editableDay: {
      get() {
        return this.datepickerValue
          ? this.$dayjs(this.datepickerValue).format('DD')
          : null;
      },
      set(value) {
        if (value.length === 2) {
          this.datepickerValue = new Date(
            this.editableYear,
            this.editableMonth - 1,
            value,
          );
        }
      },
    },

    editableMonth: {
      get() {
        return this.datepickerValue
          ? this.$dayjs(this.datepickerValue).format('MM')
          : null;
      },
      set(value) {
        if (value.length === 2) {
          this.datepickerValue = new Date(
            this.editableYear,
            value - 1,
            this.editableDay,
          );
        }
      },
    },

    editableYear: {
      get() {
        return this.datepickerValue
          ? this.$dayjs(this.datepickerValue).format('YYYY')
          : null;
      },
      set(value) {
        if (value.length === 4) {
          this.datepickerValue = new Date(
            value,
            this.editableMonth - 1,
            this.editableDay,
          );
        }
      },
    },
  },

  methods: {
    customFormatter(date) {
      return null;
    },

    onClickOutside() {
      this.isOpen = false;
    },

    onDateSelected() {
      const input = document.querySelector('.c-datepicker__input');
      input.blur();
      this.isOpen = false;
    },
  },

  watch: {
    datepickerValue(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.datepickerValue = value
    }
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss">
.c-datepicker {
  position: relative;

  &__wrapper {
    position: relative;
  }

  &--small &__wrapper {
    max-width: 230px;
  }

  &__icon {
    position: absolute;
    right: 0;
    top: 0;
    width: 55px;
    padding: 16px 16px;
    height: 100%;
    color: $colour-nhs-blue;
    pointer-events: none;
  }

  &__input {
    color: $colour-nhs-blue;
  }

  &__input-group {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 130px;
    height: 34px;
  }

  &__input-group &__input-item {
    border: none;
    outline: none;
    display: inline-block;
    width: 31%;
    height: 100%;
    text-align: center;
    color: $colour-nhs-blue;
    position: relative;
    background: none;

    &--day,
    &--month {
      width: 2.1em;
      @media screen and (min-width: 768px) {
        width: 1.75em;
      }
    }
    &--year {
      width: 3.25em;
    }
  }

  .c-form__input {
  border: 2px solid #c9ced4;
  border-radius: 4px;
  background: $colour-nhs-white;
  font-size: 16px;
  padding: 1em;
  display: block;
  width: auto;
  padding-right: 3em;
  max-width: 100%;

  &.has-errors {
    border-color: $colour-nhs-emergency-red;
  }
}
}

</style>
